import React, { Fragment } from 'react';

export default function Index({ sale_order_number }) {
  return (
    <Fragment>
      <div className="accordion-container payment-accordion">
        <div className="payment-field-card payment-field-card--info">
          <div className="payment-field-card__label">Bank Details</div>
          <div className="payment-detail-grid">
            <div className="payment-detail-item">
              <span className="payment-detail-item__label">Account Name</span>
              <span className="payment-detail-item__value">
                Luxity (pty) ltd
              </span>
            </div>
            <div className="payment-detail-item">
              <span className="payment-detail-item__label">Account Number</span>
              <span className="payment-detail-item__value">62556319509</span>
            </div>
            <div className="payment-detail-item">
              <span className="payment-detail-item__label">Bank</span>
              <span className="payment-detail-item__value">FNB</span>
            </div>
            <div className="payment-detail-item">
              <span className="payment-detail-item__label">Type</span>
              <span className="payment-detail-item__value">Cheque</span>
            </div>
            <div className="payment-detail-item">
              <span className="payment-detail-item__label">Branch Code</span>
              <span className="payment-detail-item__value">250 655</span>
            </div>
            <div className="payment-detail-item payment-detail-item--accent">
              <span className="payment-detail-item__label">
                Payment Reference
              </span>
              <span className="payment-detail-item__value">
                {sale_order_number}
              </span>
            </div>
          </div>
          <div className="payment-field-card__note">
            Please use your
            {` `}
            <b>Order No</b>
            {` `}
            as the payment reference.
          </div>
        </div>
      </div>
    </Fragment>
  );
}
